module.exports = {
  paymentType: "支付類型",
  card: "元寶/各種卡",
  gift: "禮包",
  characterId: "角色ID",
  characterName: "角色名稱",
  server: "伺服器",
  selectItem: "選擇物品",
  confirmBtn: "確認",
  rechargeBtn: "立刻儲值",
  inputRoleId: "請輸入角色ID並確認",
  noRoleId: "角色ID不存在，請重新輸入",
  supplementAllInfo: "請補齊完整的資訊",
  errorCharacterId: "角色ID有誤",
  errorCharacterName: "角色名稱不能為空",
  errorServer: "伺服器不能為空",
  errorSelectItem: "選擇物品不能為空",
  selectPayWay: "請選擇您所在的國家及付款方式。",
  introduce:
    "關於儲值： <br>1、熱血禮包、祝福禮包和經典禮包每日僅可購買一次。<br>2、在輸入角色ID後，請點擊“comfirm”確認您的角色名和伺服器，確認無誤後，便可安心儲值。<br>3、如果您在儲值中遇到任何問題，請與FB客服聯繫：熱血江湖手遊。",
  code: {
    603: "用戶資訊不存在",
    606: "商品不存在",
    607: "支付管道不存在",
    605: "沒有設置兌換比例，請聯繫客服",
    608: "角色id不存在",
    609: "訂單建立失敗",
    610: "該伺服器不允許儲存",
    611: "您在該伺服器未創建角色，請確認登入帳號是否正確",
    612: "該伺服器不存在",
    613: "支付請求",
    614: "通知遊戲失敗",
    615: "您輸入的角色ID不存在"
  },
  rechargeSuccess: "儲值完成",
  pleaseCheck: "獎勵已在遊戲內發放，請返回遊戲查看",
  resultBtn: "确定",
  someQuestions: "若儲值遇到問題，請聯繫FB客服@YulgangGlobalID"
};
